var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.528 10.056h-4.09V5.44c0-2.453-1.957-4.44-4.382-4.44S9.674 2.987 9.674 5.44v4.616h-4.09A.585.585 0 005 10.64v12.562A3.79 3.79 0 008.798 27h10.517a3.79 3.79 0 003.797-3.798V10.64a.585.585 0 00-.584-.584zM10.843 5.44c0-1.81 1.43-3.271 3.213-3.271 1.783 0 3.214 1.46 3.214 3.271v4.616h-6.427V5.44z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgBag;